var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-tree"},[_c('div',{staticClass:"top"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"tree-content"},[_c('Tree',{attrs:{"data":_vm.treeData,"show-checkbox":""},on:{"on-check-change":_vm.handleCheckChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }